<template>
  <div class="room gas-clamp">
    <RefreshBlock @refreshData="refreshData"></RefreshBlock>
    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2 class="font-bold">新风系统</h2>
      </div>
      <div class="cable-main">
        <!-- <div class="legend">
            <div class="sensor1">排气口</div>
            <div class="sensor2">进气口</div>
          </div> -->
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>新风系统</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img">
          <el-tooltip class="station-block station-block-steelbox-south-tower" content="南塔箱梁新风" effect="light" placement="top">
            <router-link class="iconfont iconshebei" to="/xihoumenFreshAir/steelbox"></router-link>
          </el-tooltip>
          <div class="stati sta-steelbox-south-tower">
            <el-tooltip effect="light" placement="bottom">
              <div slot="content" class="tooltip-slot">
                {{
                  assembleTooltip_dehumidifier(
                    "",
                    humidityTooltipErrorDehumidifierSteelboxSouthTower,
                    humidityAllowedMaxDehumidifierSteelboxSouthTower,
                    runningDehumidifierSteelboxSouthTower,
                    0,
                    "新风系统"
                  )
                }}
              </div>
              <div :class="errorDehumidifierSteelboxSouthTower" class="state-info left-pos" @dblclick="hrefToStation('/steelbox')">
                <p>南塔箱梁新风检测箱</p>
                <p>
                  <span
                    >压力: {{ pressureDehumidifierSteelboxSouthTower | toFixed }}Pa<br />
                    {{ humidityDehumidifierSteelboxSouthTower | toFixed }}% {{ temperatureDehumidifierSteelboxSouthTower | toFixed }}°C
                  </span>
                  <span :class="runningClassSteelboxSouthTower" class="valve-sign"></span>
                </p>
              </div>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>

    <div class="main-cable" v-loading="loading">
      <div class="cable-title">
        <h2>新风系统</h2>
      </div>
      <div class="cable-main">
        <!-- <div class="legend">
            <div class="sensor1">排气口</div>
            <div class="sensor2">进气口</div>
          </div> -->
        <div class="legend-station">
          <i class="iconfont iconshebei"></i>
          <span>新风系统</span>
        </div>
        <div class="legend-right">
          <div class="running">设备运行</div>
          <div class="stopped">设备停止</div>
          <div class="default">数据中断</div>
        </div>
        <div class="dir left-dir">
          <i class="iconfont icongeo-arrow-left"></i>
          <span class="dir-text">册子岛</span>
        </div>
        <div class="dir right-dir">
          <i class="iconfont icongeo-arrow-left-copy"></i>
          <span class="dir-text">金塘岛</span>
        </div>
        <div class="cable-img"></div>
      </div>
    </div>
  </div>
</template>
      
      <script>
export default {
  name: "gasClamp",
  data() {
    return {
      loading: true,
      timer: null,

      routerPrefix: "xihoumenFreshAir",
      bridgeId: "3aeeb5b1-f586-43c4-b03c-2e5880d2e541",

      //humidity, temperature
      humidityPZ0: "--",
      humidityPN0: "--",
      humidityJZ1: "--",
      humidityJN1: "--",
      humidityPZ2: "--",
      humidityPN2: "--",
      humidityJZ3: "--",
      humidityJN3: "--",
      humidityPZ4: "--",
      humidityPN4: "--",
      humidityPZM6: "--",
      humidityPNM6: "--",
      humidityJZM5: "--",
      humidityJNM5: "--",
      humidityPZM4: "--",
      humidityPNM4: "--",
      humidityJZM3: "--",
      humidityJNM3: "--",
      humidityPZM2: "--",
      humidityPNM2: "--",
      humidityJZM1: "--",
      humidityJNM1: "--",
      humidityPZM0: "--",
      humidityPNM0: "--",
      humidityPZ0Plus: "--",
      humidityPN0Plus: "--",
      humidityJZ1Plus: "--",
      humidityJN1Plus: "--",
      humidityPZ2Plus: "--",
      humidityPN2Plus: "--",
      humidityJZ3Plus: "--",
      humidityJN3Plus: "--",
      humidityPZ4Plus: "--",
      humidityPN4Plus: "--",
      humidityPZM6Plus: "--",
      humidityPNM6Plus: "--",
      humidityJZM5Plus: "--",
      humidityJNM5Plus: "--",
      humidityPZM4Plus: "--",
      humidityPNM4Plus: "--",
      humidityJZM3Plus: "--",
      humidityJNM3Plus: "--",
      humidityPZM2Plus: "--",
      humidityPNM2Plus: "--",
      humidityJZM1Plus: "--",
      humidityJNM1Plus: "--",
      humidityDehumidifierLeft: "--",
      humidityDehumidifierRight: "--",
      humidityDehumidifierEquivalentLeft: "--",
      humidityDehumidifierEquivalentRight: "--",
      humidityDehumidifierSteelboxSouthTower: "--",

      temperaturePZ0: "--",
      temperaturePN0: "--",
      temperatureJZ1: "--",
      temperatureJN1: "--",
      temperaturePZ2: "--",
      temperaturePN2: "--",
      temperatureJZ3: "--",
      temperatureJN3: "--",
      temperaturePZ4: "--",
      temperaturePN4: "--",
      temperaturePZM6: "--",
      temperaturePNM6: "--",
      temperatureJZM5: "--",
      temperatureJNM5: "--",
      temperaturePZM4: "--",
      temperaturePNM4: "--",
      temperatureJZM3: "--",
      temperatureJNM3: "--",
      temperaturePZM2: "--",
      temperaturePNM2: "--",
      temperatureJZM1: "--",
      temperatureJNM1: "--",
      temperaturePZM0: "--",
      temperaturePNM0: "--",
      temperaturePZ0Plus: "--",
      temperaturePN0Plus: "--",
      temperatureJZ1Plus: "--",
      temperatureJN1Plus: "--",
      temperaturePZ2Plus: "--",
      temperaturePN2Plus: "--",
      temperatureJZ3Plus: "--",
      temperatureJN3Plus: "--",
      temperaturePZ4Plus: "--",
      temperaturePN4Plus: "--",
      temperaturePZM6Plus: "--",
      temperaturePNM6Plus: "--",
      temperatureJZM5Plus: "--",
      temperatureJNM5Plus: "--",
      temperaturePZM4Plus: "--",
      temperaturePNM4Plus: "--",
      temperatureJZM3Plus: "--",
      temperatureJNM3Plus: "--",
      temperaturePZM2Plus: "--",
      temperaturePNM2Plus: "--",
      temperatureJZM1Plus: "--",
      temperatureJNM1Plus: "--",
      temperatureDehumidifierLeft: "--",
      temperatureDehumidifierRight: "--",
      temperatureDehumidifierSteelboxSouthTower: "--",

      pressurePZ0: "--",
      pressurePN0: "--",
      pressureJZ1: "--",
      pressureJN1: "--",
      pressurePZ2: "--",
      pressurePN2: "--",
      pressureJZ3: "--",
      pressureJN3: "--",
      pressurePZ4: "--",
      pressurePN4: "--",
      pressurePZM6: "--",
      pressurePNM6: "--",
      pressureJZM5: "--",
      pressureJNM5: "--",
      pressurePZM4: "--",
      pressurePNM4: "--",
      pressureJZM3: "--",
      pressureJNM3: "--",
      pressurePZM2: "--",
      pressurePNM2: "--",
      pressureJZM1: "--",
      pressureJNM1: "--",
      pressurePZM0: "--",
      pressurePNM0: "--",
      pressurePZ0Plus: "--",
      pressurePN0Plus: "--",
      pressureJZ1Plus: "--",
      pressureJN1Plus: "--",
      pressurePZ2Plus: "--",
      pressurePN2Plus: "--",
      pressureJZ3Plus: "--",
      pressureJN3Plus: "--",
      pressurePZ4Plus: "--",
      pressurePN4Plus: "--",
      pressurePZM6Plus: "--",
      pressurePNM6Plus: "--",
      pressureJZM5Plus: "--",
      pressureJNM5Plus: "--",
      pressurePZM4Plus: "--",
      pressurePNM4Plus: "--",
      pressureJZM3Plus: "--",
      pressureJNM3Plus: "--",
      pressurePZM2Plus: "--",
      pressurePNM2Plus: "--",
      pressureJZM1Plus: "--",
      pressureJNM1Plus: "--",
      pressureDehumidifierSteelboxSouthTower: "--",

      flowPZ0: "--",
      flowPN0: "--",
      flowJZ1: "--",
      flowJN1: "--",
      flowPZ2: "--",
      flowPN2: "--",
      flowJZ3: "--",
      flowJN3: "--",
      flowPZ4: "--",
      flowPN4: "--",
      flowPZM6: "--",
      flowPNM6: "--",
      flowJZM5: "--",
      flowJNM5: "--",
      flowPZM4: "--",
      flowPNM4: "--",
      flowJZM3: "--",
      flowJNM3: "--",
      flowPZM2: "--",
      flowPNM2: "--",
      flowJZM1: "--",
      flowJNM1: "--",
      flowPZM0: "--",
      flowPNM0: "--",
      flowPZ0Plus: "--",
      flowPN0Plus: "--",
      flowJZ1Plus: "--",
      flowJN1Plus: "--",
      flowPZ2Plus: "--",
      flowPN2Plus: "--",
      flowJZ3Plus: "--",
      flowJN3Plus: "--",
      flowPZ4Plus: "--",
      flowPN4Plus: "--",
      flowPZM6Plus: "--",
      flowPNM6Plus: "--",
      flowJZM5Plus: "--",
      flowJNM5Plus: "--",
      flowPZM4Plus: "--",
      flowPNM4Plus: "--",
      flowJZM3Plus: "--",
      flowJNM3Plus: "--",
      flowPZM2Plus: "--",
      flowPNM2Plus: "--",
      flowJZM1Plus: "--",
      flowJNM1Plus: "--",

      //running
      runningDehumidifierLeft: "--",
      runningDehumidifierRight: "--",
      runningDehumidifierSteelboxSouthTower: "--",

      //malfunction
      malfunctionDehumidifierLeft: "--",
      malfunctionDehumidifierRight: "--",

      //error
      errorPZ0: "--",
      errorPN0: "--",
      errorJZ1: "--",
      errorJN1: "--",
      errorPZ2: "--",
      errorPN2: "--",
      errorJZ3: "--",
      errorJN3: "--",
      errorPZ4: "--",
      errorPN4: "--",
      errorPZM6: "--",
      errorPNM6: "--",
      errorJZM5: "--",
      errorJNM5: "--",
      errorPZM4: "--",
      errorPNM4: "--",
      errorJZM3: "--",
      errorJNM3: "--",
      errorPZM2: "--",
      errorPNM2: "--",
      errorJZM1: "--",
      errorJNM1: "--",
      errorPZM0: "--",
      errorPNM0: "--",
      errorPZ0Plus: "--",
      errorPN0Plus: "--",
      errorJZ1Plus: "--",
      errorJN1Plus: "--",
      errorPZ2Plus: "--",
      errorPN2Plus: "--",
      errorJZ3Plus: "--",
      errorJN3Plus: "--",
      errorPZ4Plus: "--",
      errorPN4Plus: "--",
      errorPZM6Plus: "--",
      errorPNM6Plus: "--",
      errorJZM5Plus: "--",
      errorJNM5Plus: "--",
      errorPZM4Plus: "--",
      errorPNM4Plus: "--",
      errorJZM3Plus: "--",
      errorJNM3Plus: "--",
      errorPZM2Plus: "--",
      errorPNM2Plus: "--",
      errorJZM1Plus: "--",
      errorJNM1Plus: "--",
      errorDehumidifierLeft: "--",
      errorDehumidifierRight: "--",
      errorDehumidifierSteelboxSouthTower: "--",

      //running class
      runningClassLeft: "--",
      runningClassRight: "--",
      runningClassSteelboxSouthTower: "--",

      //humidity allowed max
      humidityAllowedMaxPZ0: "--",
      humidityAllowedMaxPN0: "--",
      humidityAllowedMaxJZ1: "--",
      humidityAllowedMaxJN1: "--",
      humidityAllowedMaxPZ2: "--",
      humidityAllowedMaxPN2: "--",
      humidityAllowedMaxJZ3: "--",
      humidityAllowedMaxJN3: "--",
      humidityAllowedMaxPZ4: "--",
      humidityAllowedMaxPN4: "--",
      humidityAllowedMaxPZM6: "--",
      humidityAllowedMaxPNM6: "--",
      humidityAllowedMaxJZM5: "--",
      humidityAllowedMaxJNM5: "--",
      humidityAllowedMaxPZM4: "--",
      humidityAllowedMaxPNM4: "--",
      humidityAllowedMaxJZM3: "--",
      humidityAllowedMaxJNM3: "--",
      humidityAllowedMaxPZM2: "--",
      humidityAllowedMaxPNM2: "--",
      humidityAllowedMaxJZM1: "--",
      humidityAllowedMaxJNM1: "--",
      humidityAllowedMaxPZM0: "--",
      humidityAllowedMaxPNM0: "--",
      humidityAllowedMaxPZ0Plus: "--",
      humidityAllowedMaxPN0Plus: "--",
      humidityAllowedMaxJZ1Plus: "--",
      humidityAllowedMaxJN1Plus: "--",
      humidityAllowedMaxPZ2Plus: "--",
      humidityAllowedMaxPN2Plus: "--",
      humidityAllowedMaxJZ3Plus: "--",
      humidityAllowedMaxJN3Plus: "--",
      humidityAllowedMaxPZ4Plus: "--",
      humidityAllowedMaxPN4Plus: "--",
      humidityAllowedMaxPZM6Plus: "--",
      humidityAllowedMaxPNM6Plus: "--",
      humidityAllowedMaxJZM5Plus: "--",
      humidityAllowedMaxJNM5Plus: "--",
      humidityAllowedMaxPZM4Plus: "--",
      humidityAllowedMaxPNM4Plus: "--",
      humidityAllowedMaxJZM3Plus: "--",
      humidityAllowedMaxJNM3Plus: "--",
      humidityAllowedMaxPZM2Plus: "--",
      humidityAllowedMaxPNM2Plus: "--",
      humidityAllowedMaxJZM1Plus: "--",
      humidityAllowedMaxJNM1Plus: "--",
      humidityAllowedMaxDehumidifierLeft: "--",
      humidityAllowedMaxDehumidifierRight: "--",
      humidityAllowedMaxDehumidifierEquivalentLeft: "--",
      humidityAllowedMaxDehumidifierEquivalentRight: "--",
      humidityAllowedMaxDehumidifierSteelboxSouthTower: "--",

      //humidity tooltip error
      humidityTooltipErrorPZ0: "--",
      humidityTooltipErrorPN0: "--",
      humidityTooltipErrorJZ1: "--",
      humidityTooltipErrorJN1: "--",
      humidityTooltipErrorPZ2: "--",
      humidityTooltipErrorPN2: "--",
      humidityTooltipErrorJZ3: "--",
      humidityTooltipErrorJN3: "--",
      humidityTooltipErrorPZ4: "--",
      humidityTooltipErrorPN4: "--",
      humidityTooltipErrorPZM6: "--",
      humidityTooltipErrorPNM6: "--",
      humidityTooltipErrorJZM5: "--",
      humidityTooltipErrorJNM5: "--",
      humidityTooltipErrorPZM4: "--",
      humidityTooltipErrorPNM4: "--",
      humidityTooltipErrorJZM3: "--",
      humidityTooltipErrorJNM3: "--",
      humidityTooltipErrorPZM2: "--",
      humidityTooltipErrorPNM2: "--",
      humidityTooltipErrorJZM1: "--",
      humidityTooltipErrorJNM1: "--",
      humidityTooltipErrorPZM0: "--",
      humidityTooltipErrorPNM0: "--",
      humidityTooltipErrorPZ0Plus: "--",
      humidityTooltipErrorPN0Plus: "--",
      humidityTooltipErrorJZ1Plus: "--",
      humidityTooltipErrorJN1Plus: "--",
      humidityTooltipErrorPZ2Plus: "--",
      humidityTooltipErrorPN2Plus: "--",
      humidityTooltipErrorJZ3Plus: "--",
      humidityTooltipErrorJN3Plus: "--",
      humidityTooltipErrorPZ4Plus: "--",
      humidityTooltipErrorPN4Plus: "--",
      humidityTooltipErrorPZM6Plus: "--",
      humidityTooltipErrorPNM6Plus: "--",
      humidityTooltipErrorJZM5Plus: "--",
      humidityTooltipErrorJNM5Plus: "--",
      humidityTooltipErrorPZM4Plus: "--",
      humidityTooltipErrorPNM4Plus: "--",
      humidityTooltipErrorJZM3Plus: "--",
      humidityTooltipErrorJNM3Plus: "--",
      humidityTooltipErrorPZM2Plus: "--",
      humidityTooltipErrorPNM2Plus: "--",
      humidityTooltipErrorJZM1Plus: "--",
      humidityTooltipErrorJNM1Plus: "--",
      humidityTooltipErrorDehumidifierLeft: "--",
      humidityTooltipErrorDehumidifierRight: "--",
      humidityTooltipErrorDehumidifierEquivalentLeft: "--",
      humidityTooltipErrorDehumidifierEquivalentRight: "--",
      humidityTooltipErrorDehumidifierSteelboxSouthTower: "--",

      dataNameIdDict: {
        //humidity, temperature

        humidityDehumidifierSteelboxSouthTower: "38efbd32-db59-44f7-9070-933116d1cc49",


        temperatureDehumidifierSteelboxSouthTower: "ba5b30cb-bb8b-475f-9adf-b9b78db8d785",


        pressureDehumidifierSteelboxSouthTower: "3dd9e252-3bcf-41fe-bfdd-84bfb073b0ba",



        //running

        runningDehumidifierSteelboxSouthTower: "8c36c4e3-1172-4437-9101-4c1d2ca9175d",

        //malfunction
      },

      //humidity allowed max -> id
      allowedMaxNameIdDict: {
        humidityAllowedMaxDehumidifierSteelboxSouthTower: "38efbd32-db59-44f7-9070-933116d1cc49",
      },

      //humidity, temperature -> error
      dataNameErrorNameDict: {
        humidityDehumidifierSteelboxSouthTower: "errorDehumidifierSteelboxSouthTower",
        temperatureDehumidifierSteelboxSouthTower: "errorDehumidifierSteelboxSouthTower",
        pressureDehumidifierSteelboxSouthTower: "errorDehumidifierSteelboxSouthTower",
      },

      //malfunction -> error
      malfunctionDataNameErrorNameDict: {},

      //humidity -> humidity tooltip error
      dataNameTooltipErrorNameDict: {
        humidityDehumidifierSteelboxSouthTower: "humidityTooltipErrorDehumidifierSteelboxSouthTower",
      },

      //running -> running class
      dataNameRunningClassNameDict: {
        runningDehumidifierSteelboxSouthTower: "runningClassSteelboxSouthTower",
      },

      //station id list
      stationIdList: ["df7e7dad-73e0-41d4-9f00-d2e9c91fb1a2"],
    };
  },
  filters: {
    toFixed(val) {
      if (val === 0) return "0.0";
      if (!Number(val)) return "--";
      return Number(val).toFixed(1);
    },
  },
  mounted() {
    this.getAllowedMax();
    this.getData();
    this.timer = setInterval(() => {
      this.getData();
    }, this.REFRESH_SECOND);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    refreshData() {
      this.loading = true;
      this.getData();
    },
    getData() {
      this.resetError();
      let stationRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationRequestList.push(this.$http.get(`/deviceData/Station?stationId=${stationId}`));
      });

      this.$http.all(stationRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setDataAndError(res.data);
            this.loading = false;
          });
        })
      );
    },
    setDataAndError(stationData) {
      //device id not set (device id = 'GUID') = no data
      stationData["GUID"] = {
        dataId: null,
        deviceId: "GUID",
        value: null,
        createdDate: "0001-01-01T00:00:00",
        dataDate: "0001-01-01T00:00:00",
        dataType: "VALUE",
        errorLevel: "Warning",
      };

      for (let dataName in this.dataNameIdDict) {
        const dataId = this.dataNameIdDict[dataName];
        if (stationData[dataId] !== undefined) {
          this[dataName] = stationData[dataId].value;

          // //set value for running sign
          // if (this.dataNameRunningTooltipNameDict[dataName] !== undefined && this.dataNameRunningClassNameDict[dataName] != undefined) {
          //   let runningData = stationData[dataId];
          //   if (runningData.value === 1) {
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "运行";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "running";
          //   } else if (runningData.errorLevel !== "Warning") {
          //     //empty data value also === 0
          //     this[this.dataNameRunningTooltipNameDict[dataName]] = "停止";
          //     this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
          //   }
          // }

          //set value for running sign
          if (this.dataNameRunningClassNameDict[dataName] != undefined) {
            let runningData = stationData[dataId];
            if (runningData.value === 1) {
              this[this.dataNameRunningClassNameDict[dataName]] = "running";
            } else if (runningData.errorLevel !== "Warning") {
              //empty data value also === 0
              this[this.dataNameRunningClassNameDict[dataName]] = "stopped";
            }
          }

          if (this.dataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameErrorNameDict[dataName];
            this[errorName] = this.getErrorLevelFromMultipleDevice(this[errorName], stationData[dataId].errorLevel);
          }

          if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
            const errorName = this.dataNameTooltipErrorNameDict[dataName];
            this[errorName] = stationData[dataId].errorLevel;
          }

          if (this.malfunctionDataNameErrorNameDict[dataName] !== undefined) {
            const errorName = this.malfunctionDataNameErrorNameDict[dataName];
            if (this[errorName] === "" && stationData[dataId].value && stationData[dataId].value > 0) {
              this[errorName] = "Error";
            }
          }
        }
      }
    },
    getAllowedMax() {
      let stationMetaRequestList = [];
      this.stationIdList.forEach((stationId) => {
        stationMetaRequestList.push(this.$http.get(`/bridge/StationInfo?stationId=${stationId}`));
      });

      this.$http.all(stationMetaRequestList).then(
        this.$http.spread((...resList) => {
          resList.forEach((res) => {
            this.setAllowedMax(res.data);
          });
        })
      );
    },
    setAllowedMax(stationData) {
      let deviceIdDevicedict = {};
      if (stationData.deviceList) {
        stationData.deviceList.forEach((item) => {
          deviceIdDevicedict[item.deviceId] = item;
        });
      }

      for (let allowedMaxName in this.allowedMaxNameIdDict) {
        const dataId = this.allowedMaxNameIdDict[allowedMaxName];
        if (deviceIdDevicedict[dataId] !== undefined) {
          let device = deviceIdDevicedict[dataId];
          this[allowedMaxName] = device.allowedMax;
        }
      }
    },
    getErrorLevelFromMultipleDevice(newErrorLevel, currentErrorLevel) {
      if (currentErrorLevel === "Error") {
        return "Error";
      } else if (currentErrorLevel === "Warning") {
        if (newErrorLevel === "Error") {
          return "Error";
        } else {
          return "Warning";
        }
      } else {
        return newErrorLevel;
      }
    },
    resetError() {
      for (let dataName in this.dataNameIdDict) {
        if (this.dataNameErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameErrorNameDict[dataName];
          this[errorName] = "";
        }

        if (this.dataNameTooltipErrorNameDict[dataName] !== undefined) {
          const errorName = this.dataNameTooltipErrorNameDict[dataName];
          this[errorName] = "";
        }
      }
    },
    assembleTooltip_sensor(name, errorLevel, allowedMax) {
      let result = "";
      if (name) {
        result += name + ": ";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if (
        (errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") &&
        allowedMax !== undefined &&
        allowedMax !== null &&
        !isNaN(parseInt(allowedMax))
      ) {
        if (allowedMax === 0) {
          result += "(无限制)";
        } else {
          result += "(<" + allowedMax + "%RH)";
        }
      }

      return result;
    },
    assembleTooltip_dehumidifier(name, errorLevel, allowedMax, runningFlag, errorFlag, dehumidifierName) {
      let result = "";
      if (name) {
        result += name + ": ";
      }
      if (!dehumidifierName || dehumidifierName === "") {
        dehumidifierName = "除湿机";
      }

      if (errorLevel.toLowerCase() === "normal") {
        result += "湿度正常";
      } else if (errorLevel.toLowerCase() === "warning") {
        result += "数据中断";
      } else if (errorLevel.toLowerCase() === "error") {
        result += "湿度超限";
      }

      if ((errorLevel.toLowerCase() === "normal" || errorLevel.toLowerCase() === "error") && allowedMax && !isNaN(parseInt(allowedMax))) {
        result += "(<" + allowedMax + "%RH)";
      }

      if (errorLevel.toLowerCase() !== "warning") {
        if (runningFlag > 0) {
          result += ", " + dehumidifierName + "运行";
        } else if (runningFlag === 0) {
          result += ", " + dehumidifierName + "停止";
        }
      }

      if (errorFlag > 0) {
        result += ", 故障报警";
      }

      return result;
    },
    hrefToScenario(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + "/dataHistory?bridgeId=" + this.bridgeId + "&scenarioId=" + id);
    },
    hrefToStation(id) {
      if (!id || id === "") {
        return;
      }

      this.$router.push("/" + this.routerPrefix + id);
    },
  },
};
</script>
      
      <style lang="scss" scoped>
@keyframes breathee-warning {
  0% {
    border-color: rgba(255, 255, 0, 0.3);
  }
  100% {
    border-color: #ffff00;
    // background: rgba(255, 255, 255, 0.7);
  }
}
@keyframes breathee-error {
  0% {
    border-color: rgba(255, 0, 0, 0.3);
  }
  100% {
    border-color: #ff0000;
    // background: rgba(255, 255, 255, 0.7);
  }
}

.tooltip-slot {
  line-height: 1.4;
}

.gas-clamp {
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  height: calc(100% - 20px) !important;
  // min-height: 630px !important;

  .main-cable {
    width: 100%;
    height: 48%;
    padding: 0;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    min-height: 370px;

    .cable-title {
      width: 50px;
      text-align: center;
      display: flex;
      background-color: #fff;
      justify-content: center;
      align-items: center;

      h2 {
        padding: 0 10px;
        font-weight: 400;
        font-size: 24px;
        line-height: 35px;
        font-weight: bold;
        color: #515151;
      }
    }

    .cable-main {
      position: relative;
      min-width: 1200px;
      width: calc(100% - 50px);
      background: linear-gradient(#ceeaf0, #e9f1ef);
      display: flex;
      justify-content: center;
      align-items: center;

      .legend {
        position: absolute;
        left: 75px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .sensor1:after {
          background: #c7798b;
        }
        .sensor2:after {
          background: #3376c7;
        }
      }
      .legend-right {
        position: absolute;
        right: 70px;
        top: 50px;
        div {
          padding-left: 30px;
          height: 20px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
          &:after {
            position: absolute;
            left: 0;
            top: 0;
            content: " ";
            overflow: hidden;
            display: block;
            height: 20px;
            width: 20px;
            border-radius: 10px;
          }
        }
        .default:after {
          background: #ffff00;
        }
        .running:after {
          background: #67dd34;
        }
        .stopped:after {
          background: #a0a0a0;
        }
      }
      .legend-station {
        position: absolute;
        left: 73px;
        top: 108px;

        i {
          font-size: 24px;
          color: #ed6a5a;
        }
        span {
          padding-left: 8px;
          bottom: 3px;
          margin-bottom: 10px;
          line-height: 20px;
          font-size: 14px;
          color: #515151;
          position: relative;
        }
      }

      .dir {
        position: absolute;
        top: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        color: #2a387a;
        i {
          font-size: 30px;
        }
        .dir-text {
          font-size: 20px;
        }
      }
      .left-dir {
        left: 250px;
      }
      .right-dir {
        flex-direction: row-reverse;
        right: 250px;
      }
      .cable-img {
        position: relative;
        z-index: 0;
        width: 1200px;
        height: 300px;
        background-position: 50%;
        background-repeat: no-repeat;
        background-size: contain;
        background-image: url("../../assets/image/xihoumen/bridgeLine.png");
        background-position-y: 100%;

        .station-block {
          position: absolute;
          color: #ed6a5a;
          font-size: 24px;
          text-decoration: none;
        }

        .stati {
          position: absolute;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
            background: #ed6a5a;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            text-decoration: none;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            background-color: rgba(246, 250, 255, 0.9);
            &:before {
              background-color: #ed6a5a;
            }
            & > p {
              margin: 0;
              white-space: nowrap;
              white-space: nowrap;
              display: flex;
              justify-content: space-between;
              align-items: baseline;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 94%;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }

            .valve-sign {
              margin-top: auto;
              margin-bottom: auto;
              width: 12px;
              height: 12px;
              background-color: #ffff00;
              animation: breathee-valve-sign-default 1500ms infinite alternate ease-in-out;
              border-radius: 10px;
              margin-left: 12px;

              &.running {
                background-color: #67dd34;
                animation: none;
              }
              &.stopped {
                background-color: #a0a0a0;
                animation: none;
              }
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
        }

        .clip {
          position: absolute;
          width: 16px;
          height: 16px;
          border-radius: 8px;
          &:before,
          &:after {
            position: absolute;
            display: block;
            content: "";
            height: 2px;
          }
          &:before {
            width: 50px;
          }
          &:after {
            width: 15px;
          }
          .state-info {
            font-size: 14px;
            line-height: 17px;
            color: #515151;
            text-align: right;
            min-width: 75px;
            transform: translateY(-50%);
            position: absolute;
            border-radius: 10px;
            box-sizing: border-box;
            padding: 6px 8px 6px 6px;
            border: 2px solid transparent;
            box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
            & > p {
              margin: 0;
              white-space: nowrap;
              &:first-child {
                font-size: 13px;
              }
            }
            &.right-pos:before {
              right: 0;
              transform: translate(50%, -50%);
            }
            &.left-pos:before {
              left: -8px;
              transform: translate(50%, -50%);
            }
            &.bottom-pos:before {
              left: 50%;
              top: 90%;
              transform: translate(0%, 0%);
            }
            &.top-pos:before {
              left: 50%;
              top: -3px;
              transform: translate(0%, 0%);
            }
            &:before {
              position: absolute;
              display: block;
              content: "";
              height: 8px;
              width: 8px;
              border-radius: 4px;
              top: 50%;
            }
          }
          .Warning {
            border-color: #ffff00;
            animation: breathee-warning 1500ms infinite alternate ease-in-out;
          }
          .Error {
            border-color: #ff0000;
            animation: breathee-error 1500ms infinite alternate ease-in-out;
          }
          &.sensor1 {
            background: #c7798b;
            &:after,
            &:before {
              background: #c7798b;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #c7798b;
              }
            }
          }
          &.sensor2 {
            background: #3376c7;
            &:after,
            &:before {
              background: #3376c7;
            }
            .state-info {
              background-color: rgba(246, 250, 255, 0.9);
              &:before {
                background-color: #3376c7;
              }
            }
          }
        }

        .sensor-right-1 {
          top: 184px;
          left: 1132px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -165px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-3 {
          top: 153px;
          left: 1050px;
          &::before {
            bottom: -40px;
            left: -34px;
            width: 100px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -89px;
            left: 24px;
          }
          .state-info {
            right: -165px;
            top: 103px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-5 {
          top: 117px;
          left: 962px;
          &::before {
            bottom: 35px;
            left: -17px;
            width: 60px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 64px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: -49px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-13 {
          top: 117px;
          left: 937px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 40px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-11 {
          top: 150px;
          left: 835px;
          &::before {
            bottom: 22px;
            left: -21px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -26px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-9 {
          top: 170px;
          left: 732px;
          &::before {
            bottom: -25px;
            left: -22px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-7 {
          top: 180px;
          left: 625px;
          &::before {
            bottom: -5px;
            left: -4px;
            width: 25px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -61px;
            top: 59px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-5 {
          top: 170px;
          left: 518px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-3 {
          top: 150px;
          left: 405px;
          &::before {
            bottom: 22px;
            left: -2px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-1 {
          top: 117px;
          left: 300px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -165px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-5 {
          top: 117px;
          left: 275px;
          &::before {
            bottom: 35px;
            left: -28px;
            width: 60px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 64px;
            left: -18px;
          }
          .state-info {
            right: 35px;
            top: -49px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-3 {
          top: 157px;
          left: 175px;
          &::before {
            bottom: -40px;
            left: -51px;
            width: 100px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -89px;
            left: -24px;
          }
          .state-info {
            right: 40px;
            top: 103px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-1 {
          top: 182px;
          left: 72px;
          &::before {
            bottom: 22px;
            left: -23px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -27px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-2 {
          top: 168px;
          left: 1093px;
          &::before {
            bottom: 22px;
            left: -3px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -165px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-right-4 {
          top: 132px;
          left: 998px;
          &::before {
            bottom: 38px;
            left: -21px;
            width: 70px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 73px;
            left: 20px;
          }
          .state-info {
            right: -165px;
            top: -58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-12 {
          top: 135px;
          left: 885px;
          &::before {
            bottom: 45px;
            left: -45px;
            width: 90px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 89px;
            left: -23px;
          }
          .state-info {
            right: 40px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-10 {
          top: 158px;
          left: 805px;
          &::before {
            bottom: 22px;
            left: -21px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -26px;
          }
          .state-info {
            right: 40px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-8 {
          top: 177px;
          left: 675px;
          &::before {
            bottom: -25px;
            left: -22px;
            width: 70px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -59px;
            left: 18px;
          }
          .state-info {
            right: -162px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-6 {
          top: 177px;
          left: 570px;
          &::before {
            bottom: -25px;
            left: -32px;
            width: 70px;
            transform: rotate(280deg);
          }
          &::after {
            bottom: -59px;
            left: -18px;
          }
          .state-info {
            right: 33px;
            top: 74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-4 {
          top: 158px;
          left: 440px;
          &::before {
            bottom: 22px;
            left: -2px;
            width: 40px;
            transform: rotate(120deg);
          }
          &::after {
            bottom: 39px;
            left: 27px;
          }
          .state-info {
            right: -170px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-middle-2 {
          top: 135px;
          left: 350px;
          &::before {
            bottom: 45px;
            left: -30px;
            width: 90px;
            transform: rotate(100deg);
          }
          &::after {
            bottom: 89px;
            left: 23px;
          }
          .state-info {
            right: -165px;
            top: -74px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-4 {
          top: 132px;
          left: 240px;
          &::before {
            bottom: 38px;
            left: -33px;
            width: 70px;
            transform: rotate(80deg);
          }
          &::after {
            bottom: 73px;
            left: -19px;
          }
          .state-info {
            right: 34px;
            top: -58px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .sensor-left-2 {
          top: 168px;
          left: 145px;
          &::before {
            bottom: 22px;
            left: -20px;
            width: 40px;
            transform: rotate(60deg);
          }
          &::after {
            bottom: 39px;
            left: -25px;
          }
          .state-info {
            right: 35px;
            top: -23px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }

        .station-block-left {
          top: 108px;
          left: 282px;
        }

        .sta-left {
          top: 108px;
          left: 282px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -73px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 130px;
          }
        }

        .station-block-right {
          top: 108px;
          left: 945px;
        }

        .sta-right {
          top: 108px;
          left: 945px;
          &::before {
            bottom: 15px;
            left: -18px;
            width: 60px;
            transform: rotate(90deg);
          }
          &::after {
            bottom: -49px;
            left: -17px;
            width: 0;
          }
          .state-info {
            right: -72px;
            top: -76px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 115px;
          }
        }

        .station-block-steelbox-south-tower {
          top: 180px;
          left: 945px;
        }

        .sta-steelbox-south-tower {
          top: 180px;
          left: 945px;
          &::before {
            bottom: -45px;
            left: -10px;
            width: 55px;
            transform: rotate(260deg);
          }
          &::after {
            bottom: -72px;
            left: 23px;
          }
          .state-info {
            right: -185px;
            top: 71px;
            // 在数据为空时维持宽度, 以免断连
            min-width: 145px;
          }
        }
      }
    }
  }
}
</style>